
import { Component, Vue, Watch, } from 'vue-property-decorator';
import { Store, } from '~/apps/pay-bill/store';
import PayBillProgressSteps from '~/components/pay-bill/pay-bill-progress-steps.vue';
import Spinner from '~/components/spinner/spinner.vue';
import UnauthedNav from '~/components/unauthed-nav/unauthed-nav.vue';

@Component({
	components: {
		Alert: () => import('~/components/alert/alert.vue'),
		PayBillProgressSteps,
		Spinner,
		UnauthedNav,
	},
	metaInfo: {
		title: 'Quick pay bill - Southern Water',
		meta: [
			{
				name: 'description',
				content: 'We\'ve made paying your bill online using a debit or credit card easier for you. Make a payment today.',
			},
		],
	},
})
export default class PayBillApp extends Vue {
	get currentStep() {
		return Store.state.currentStep;
	}

	get showSpinner() {
		return Store.state.showSpinner;
	}

	get activeAlert() {
		return Store.state.alertModule.activeAlert;
	}

	logo = Store.getters.getGlobalConfigValue('SouthernWaterLogo');
	logoWidth = Store.getters.getGlobalConfigValue('SouthernWaterLogoWidth');
	logoHeight = Store.getters.getGlobalConfigValue('SouthernWaterLogoHeight');
	get logoDetails() {
		return Store.getters.getGlobalConfigValue('SouthernWaterLogoDetails');
	}

	closeAlert() {
		Store.commit.dismissActiveAlert();
	}

	@Watch('$route')
	onRouteChange() {
		this.$nextTick(() => {
			const focusTarget = document.querySelector('header') as HTMLElement;
			focusTarget.setAttribute('tabindex', '-1');
			focusTarget.focus();
			focusTarget.removeAttribute('tabindex');
		});
	}
}
